// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"f83a755e","419":"32cc6504","458":"70cfa639","473":"09ad802d","503":"527eb814","774":"38f24982","787":"462d0490","858":"9473228e","935":"3769a5fe","942":"1ea637a1"}[chunkId] + ".chunk.js";
};